<template>
  <div class="page">
    <header-bar slot="head">
      <span slot="left">{{ $t("mall_modules_editrole_fanhui") }}</span>
      <span>{{ $t(objSave.centerTitle) }}</span>
    </header-bar>
    <div class="page-content">
      <div class="account">
        <div class="account-infos">
          <div class="account-icon">
            <div>
              <img class="avatar" :src="RoleIcon" />
              <div>
                <div class="ContactPeople" v-if="ContactInfo.ContactName">{{ ContactInfo.ContactName }}</div>
                <div v-else class="ContactPeople">{{ $t("system.HowToCall") }}</div>
                <div class="ContactPhone" v-if="ContactInfo.ContactPhone">{{ ContactInfo.ContactPhone }}</div>
                <div v-else class="ContactPhone">{{ $t("system.PerfectInformation") }}</div>
              </div>
            </div>
            <!-- <img style="width:0.372rem" src="/static/img/left1.png" /> -->
          </div>
          <div class="border_bottom"></div>
          <div class="account-item" @click="ChangeAccount(AccountList)" v-if="AccountList.AuthType != 10230" v-for="AccountList in AccountLists">
            <label>{{ $t("Categorys." + AccountList.AuthCode) }}</label>
            <div>
              <span style="vertical-align: middle;" :style="{ color: AccountList.IsData ? '' : '#666' }">{{ $t(AccountList.UserAct) }}</span>
              <img style="width:0.372rem;vertical-align: middle" src="/static/img/left1.png" />
            </div>
          </div>
          <div class="account-item" v-if="AccountList.AuthType == 10230 && AccountList.IsData" v-for="AccountList in AccountLists">
            <label>{{ $t("Categorys." + AccountList.AuthCode) }}</label>
            <div>
              <span style="vertical-align: middle;color: #12a3ff" @click="weChatUnbundling(AccountList)">{{ $t("system_user_account_account_jiebang") }}</span>
            </div>
          </div>
          <div class="border_bottom"></div>
        </div>
        <div class="account-logout">
          <div class="account-item">
            <label>{{ $t("system.Language") }}</label>
            <div class="language-toggle">
              <span class="langItem" :class="{ on: toggleFlag == 'cn' }" @click="toggle('cn')">{{ $t("system.Chinese") }}</span>
              <span class="langItem" :class="{ on: toggleFlag == 'en' }" @click="toggle('en')">{{ $t("system.English") }}</span>
              <span class="langItem" :class="{ on: toggleFlag == 'jp' }" @click="toggle('jp')">{{ $t("system.Japanese") }}</span>
            </div>
          </div>
        </div>
        <div class="account-exitLogin">
          <div @click="exit" v-if="TicketID">{{ $t("system.ExitLogin") }}</div>
          <div @click="exit" v-else>{{ $t("system.LoginTxt") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .avatar {
    width: 1.596rem;
    height: 1.596rem;
    border-radius: 50%;
  }

  .language-toggle {
    position: relative;
    background-color: #ddd;
    font-size: 0;
    width: 4.5rem;
    height: 0.5rem;
  }

  .langItem {
    position: relative;
    z-index: 1;
    display: inline-block;
    line-height: 0.5rem;
    text-align: center;
    color: #fff;
    font-size: 0.3rem;
    width: 1.5rem;
    height: 0.5rem;
  }

  .language-toggle .on {
    background-color: #12a3ff;
  }

  .header-menu {
    background-color: #12a3ff;
  }

  .page-content {
    top: 2.12rem;
  }

  .account {
    padding: 0.133rem 0.133rem 0 0.133rem;
  }

  .account-infos {
    background-color: #fff;
    border-radius: 0.133rem;
  }

  .account-icon {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.266rem;
  }

  .ContactPeople {
    color: #999;
    height: 0.532rem;
    line-height: 0.532rem;
    text-align: left;
  }

  .ContactPhone {
    color: #666;
    height: 0.665rem;
    line-height: 0.665rem;
  }

  .account-icon > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.3192rem;
  }

  .account-icon > div:first-child img {
    margin: 0 0.266rem;
  }

  .account-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.266rem;
    height: 1.064rem;
  }

  .account i {
    display: inline-block;
    width: 0.266rem;
    height: 100%;
  }

  .account-logout,
  .account-changePassword {
    margin-top: 0.266rem;
    background-color: #fff;
    border-radius: 0.106rem;
  }

  .account-exitLogin {
    margin-top: 1.064rem;
    padding: 0 0.532rem;
  }

  .account-exitLogin > div {
    background-color: #12a3ff;
    height: 0.93rem;
    line-height: 0.93rem;
    text-align: center;
    color: #fff;
    border-radius: 0.106rem;
  }
</style>
<script>
  import UserService from "@/service/UserService";
  import navBar from "../../modules/navBar.vue";
  import { loadLanguageAsync } from "@/lang/index";
  export default {
    data() {
      return {
        objSave: {
          centerTitle: "system.Account",
          rightTitle: {},
        },
        toggleFlag: "cn",
        ContactInfo: {},
        AccountLists: [
          {
            AuthType: 10222,
            UserAct: "system.RetrievePwd",
            IsData: false,
            AuthCode: "MobileAuth",
          },
          {
            AuthType: 10220,
            UserAct: "system.ElectronicBills",
            IsData: false,
            AuthCode: "EmailAuth",
          },
          {
            AuthType: 10230,
            UserAct: "",
            IsData: false,
            AuthCode: "WeixinAuth",
          },
        ],
        RoleIcon: this.getImgs("avatar.png"),
        ContactInfoTime: null,
        cloneAccountLists: [],
      };
    },
    computed: {
      TicketID() {
        return this.profile && this.profile.TicketID;
      },
      UserID() {
        return this.profile && this.profile.UserID;
      },
    },
    mounted() {
      let __self = this;
      __self.cloneAccountLists = __self.AccountLists;
      if (window.localStorage.lange) {
        __self.toggleFlag = window.localStorage.lange;
      }
      if (window.localStorage.RoleInfo) {
        if (JSON.parse(window.localStorage.RoleInfo).RoleIcon != "") {
          __self.RoleIcon = JSON.parse(window.localStorage.RoleInfo).RoleIcon;
        }
      }
    },
    activated() {
      let __self = this;
      __self.__init();
      if (__self.UserID && __self.UserID != "") {
        __self.getContactList();
      } else {
        __self.ContactInfoTime = setTimeout(function() {
          __self.getContactList();
        }, 1000);
      }
    },
    deactivated() {
      let __self = this;
      window.clearTimeout(__self.ContactInfoTime);
    },
    methods: {
      isWeiXin() {
        let __self = this;
        let userAgent = window.navigator.userAgent;
        if (userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
          return true;
        } else {
          return false;
        }
      },
      getContactList() {
        let __self = this;
        let data = {
          RoleID: __self.UserID,
        };
        UserService.getContactList(data).then(function(json) {
          if (json.isSucc) {
            let lists = _.orderBy(json.result.entities, ["IsDefault"], ["asc"]);
            if (lists.length > 0) {
              __self.ContactInfo = lists[0];
            }
          }
        });
      },
      // getContactInfo() {
      //   let __self = this;
      //   UserService.getContactInfo(__self.ContactID).then(function (json) {
      //     if (json.isSucc) {
      //       __self.ContactInfo = json.result;
      //     }
      //   })
      // },
      __init() {
        let __self = this;
        UserService.getAccountList().then(function(json) {
          if (json.isSucc) {
            let results = _.filter(json.result.entities, o => {
              return o.UserAct != __self.$store.getters.ticketInfo.DepartmentID;
            });
            if (results.length > 0) {
              for (let j = 0; j < __self.AccountLists.length; j++) {
                let AccountList = __self.AccountLists[j];
                AccountList.IsData = false;
                for (let i = 0; i < results.length; i++) {
                  let result = results[i];

                  if (result.AuthType == AccountList.AuthType) {
                    AccountList.UserAct = result.UserAct;
                    AccountList.IsData = true;
                  }
                }
              }
            }
          }
        });
      },
      ToEditProfile(ContactID) {
        let __self = this;
        __self.$router.push({
          path: "/system/user/editProfile",
          query: {
            ContactID: ContactID,
          },
        });
      },
      ToAccountRelating() {
        let __self = this;
        __self.$router.push({
          path: "/system/user/accountRelating",
        });
      },
      ToEditPassword() {
        let __self = this;
        __self.$router.push({
          path: "/system/user/editPassword",
        });
      },
      exit() {
        var __self = this;
        window.localStorage.removeItem("RoleInfo");
        let gotoSignIn = () => {
          location.replace("/login");
        };
        __self.$store
          .dispatch("signOut")
          .then(gotoSignIn)
          .catch(gotoSignIn);
      },
      toggle(value) {
        let __self = this;
        __self.toggleFlag = value;
        window.localStorage.lange = value;
        loadLanguageAsync(value).then(() => {
          __self.$i18n.locale = window.localStorage.lange;
        });
      },
      ChangeAccount(AccountList) {
        let __self = this;
        __self.$router.push({
          name: "BindingAccount",
          query: {
            AuthType: AccountList.AuthType,
            IsData: AccountList.IsData,
            AuthCode: AccountList.AuthCode,
          },
        });
      },
      weChatUnbundling(AccountList) {
        let __self = this;
        UserService.deleteAccountInfo(AccountList.UserAct).then(json => {
          if (json.isSucc) {
            __self.__init();
            __self.getContactList();
            __self.AccountLists = __self.cloneAccountLists;
            $utils.confirm(__self.$t("share.succ.WeChat"), undefined, function(value) {
              if (value) {
                if (WeixinJSBridge) {
                  WeixinJSBridge.call("closeWindow");
                }
              }
            });
          }
        });
      },
    },

    components: {
      navBar,
    },
  };
</script>
